export const FILTER_SELECTION_TYPES = {
	SINGLE: "single",
	MULTIPLE: "multiple",
	RANGE: "range",
};
